import axios from 'axios'
import React, { useEffect, useState, CSSProperties } from 'react'
import { Link, useParams } from 'react-router-dom'
import { ClipLoader, HashLoader } from "react-spinners";
// import useSound from 'use-sound';
// import boopSfx from './sound1.mp3';



const Successpage = () => {
    const { id } = useParams()
    const [loading, setloading] = useState(false)
    const [data, setdata] = useState(null)
    // const [play] = useSound(boopSfx);

    useEffect(() => {
        callforapi()

    }, [])


    function formatCustomDate(date) {
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
            "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

        const day = date.getDate();
        const month = months[date.getMonth()];
        const year = date.getFullYear();

        let hours = date.getHours();
        const minutes = date.getMinutes();
        const ampm = hours >= 12 ? 'pm' : 'am';

        // Convert to 12-hour format
        hours = hours % 12;
        hours = hours ? hours : 12; // '0' hours should be '12'

        // Pad minutes with a leading zero if less than 10
        const formattedMinutes = minutes < 10 ? '0' + minutes : minutes;

        return `${day} ${month} ${year} at ${hours}:${formattedMinutes} ${ampm}`;
    }



    const callforapi = async () => {
        setloading(true)
        const result = await axios.post(`https://reward-day-bg984.ondigitalocean.app/contact/getusertrickdta/${id}`)
        setdata(result?.data?.data)
        setTimeout(() => {
            // play()

            setloading(false)
        }, 2000);

    }



    return (
        <div className="mobile-container ">
            {
                loading ? <div style={{ backgroundColor: 'white', height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <HashLoader
                        color='green'

                        size={70}
                        aria-label="Loading Spinner"
                        data-testid="loader"
                    />
                </div> :


                    data?.bankid == id ?


                        <div style={{ backgroundColor: 'AccentColor', height: '100vh', border: 'none' }}>



                            <div style={{ paddingTop: 30, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                                <img width={90} src='https://cdn-icons-png.flaticon.com/512/7518/7518748.png' />
                                <span style={{ marginTop: 12, fontWeight: 'bold', fontSize: 40 }}><span style={{ fontWeight: 'normal', marginRight: 5 }}>₹</span>{data?.usercb}</span>
                                <span style={{ color: 'gray', fontFamily: 'revert-layer', fontSize: 14, marginTop: 18 }}>Paid to</span>
                                <span style={{ marginTop: 7, fontWeight: 'normal', fontSize: 22 }}>{data?.upiidname}</span>
                                <span style={{ color: 'gray', fontFamily: 'revert-layer', fontSize: 14, marginTop: 10 }}>{formatCustomDate(new Date(data?.createdAt))}</span>
                                <span style={{ color: 'gray', fontFamily: 'revert-layer', fontSize: 12, marginTop: 30, display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center' }}>Powered by <img style={{ marginLeft: 5 }} width={45} src='https://upload.wikimedia.org/wikipedia/commons/thumb/e/e1/UPI-Logo-vector.svg/960px-UPI-Logo-vector.svg.png' /></span>



                            </div>

                            <div style={{ marginTop: 100, color: 'white', marginLeft: 10, padding: 5, display: 'flex', flexDirection: 'column' }}>
                                <span style={{ color: 'gray', fontSize: 15, fontWeight: 'bold', margin: 5 }}>
                                    UPI ID
                                </span>
                                <span style={{ color: 'black', fontSize: 13, fontWeight: 'normal', margin: 5 }}>
                                    {data?.upiid}
                                </span>
                                <span style={{ color: 'gray', fontSize: 15, fontWeight: 'bold', margin: 5 }}>
                                    UPI Transaction ID
                                </span>
                                <span style={{ color: 'black', fontSize: 13, fontWeight: 'normal', margin: 5 }}>
                                    {data?.bankid}
                                </span>
                            </div>


                        </div> :
                        <div style={{ backgroundColor: 'white', height: '100vh', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                            <img width={100} src='https://cdn-icons-png.flaticon.com/512/1304/1304038.png' />
                            <p>Failed</p>
                        </div>

            }
        </div>

    )
}

export default Successpage